export default {
  AUTO     : 'auto',
  METADATA : 'metadata',
  NONE     : 'none'
};



// WEBPACK FOOTER //
// ./src/enums/preload.js